import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@commonNodeModules/@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { environment } from '@environments/environment';
import { globalEnvironment } from '@environments/globalEnvironment';
import { HelpdeskService } from '@services/helpdesk.service';
import { TranslationService } from '@services/translation.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-help-public',
	templateUrl: './help-public.component.html',
	styleUrls: ['./help-public.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, TranslatePipe]
})
export class HelpPublicComponent {
	private useNewHelpdesk = false;
	private languageChangedSubscription: Subscription
	@ViewChild("helpDropdown") helpDropdown: NgbDropdown;

	constructor(private helpdeskService: HelpdeskService, private translationService: TranslationService) { }

	public onHoverDropdown() {
		this.helpDropdown.open()
	}

	public onLeaveDropdown() {
		this.helpDropdown.close()
	}

	public async openHelpdesk() {
		let useNewHelpdesk = await this.helpdeskService.getUseNewHelpdesk();
		let helpdeskUrl = !useNewHelpdesk ? `${environment.helpdesk}/Solution/ADE_BESUCHER_FAQ/Content/Faq-2_35621` :
			await this.helpdeskService.getHelpdeskRoute(globalEnvironment.helpdeskHeader.solution, globalEnvironment.helpdeskHeader.helpId);

		// Spracheinstellung anfügen		
		helpdeskUrl += (helpdeskUrl.includes("?") ? "&" : "?") + "lang=" + this.translationService.getLanguage();

		window.open(helpdeskUrl, "_blank");
	}
}